import { render, staticRenderFns } from "./SpeechDetail.vue?vue&type=template&id=0300be04&scoped=true&"
import script from "./SpeechDetail.vue?vue&type=script&lang=js&"
export * from "./SpeechDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpeechDetail.vue?vue&type=style&index=0&id=0300be04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300be04",
  null
  
)

export default component.exports